import React from 'react'
import StatisticsPanel from '../../Component/adminComp/StatisticsPanel'

const Statistics = () => {
  return (
    <StatisticsPanel/>
  )
}

export default Statistics